<template>
  <div class="cloud-assets-tab">
    <div class="cloud-assets-tab__header">
      <div class='cloud-assets-tab__header__top'>
        <div class='cloud-assets-tab__header__top__left'>
          <filtered-search
            v-if='isCloudInstancesTab'
            class='search-filter'
            @searchInput="searchChange"
            @filtersInput="filtersChange"
            :show-filters="true"
            :filters="this.filtersCloud"
            :filter-items="this.filterSearchCloud"
            :searchItem='this.searchCloud'
            :key='"cloud_search"'
          />
          <filtered-search
            v-else-if='isCloudBucketsTab'
            class='search-filter'
            @searchInput="searchChange"
            @filtersInput="filtersChange"
            :show-filters="true"
            :filters="this.filtersBucket"
            :filter-items="this.filterSearchBucket"
            :searchItem='this.searchBucket'
            :key='"bucket_search"'
          />
          <filtered-search
            v-else
            class='search-filter'
            @searchInput="searchChange"
            @filtersInput="filtersChange"
            :show-filters="true"
            :filters="this.filtersServices"
            :filterItems='this.filterSearchServices'
            :searchItem='this.searchServices'
            :key='"services_search"'
          />
          <div class="cloud-assets-tab__header__top__left__filter">
            <v-switch
              v-if='isCloudBucketsTab || isCloudInstancesTab'
              v-model="exposedValue"
              :label="$t('configuration.exposed.only')"
            />
          </div>
          <div class="cloud-assets-tab__header__top__left__show-suppress" v-if='isCloudBucketsTab || isCloudInstancesTab'>
            <v-switch
              v-model="showSuppressValue"
              :label="suppressedToggleLabel"
            ></v-switch>
          </div>
        </div>
        <div class='cloud-assets-tab__header__top__toggle-suppress' v-if='isCloudBucketsTab || isCloudInstancesTab'>
          <v-btn class='toggle-suppress-asset toggle-suppress-asset--suppress' :disabled='isSuppressAssetDisabled' @click='toggleSuppressAssetsClicked'>
            {{ toggleSuppressButtonLabel }}
          </v-btn>
          <download-c-s-v class="download-csv-btn" :class="{'disabled': isDownloadCsvDisabled}" @click="downloadCSVReport"/>
        </div>
        <div class='cloud-assets-tab__header__top__toggle-suppress' v-if='isCloudComplianceTab'>
          <v-btn class='toggle-suppress-asset' :disabled='isComplianceStatsDisabled'  @click='statsClicked'>
            <template v-slot:default>
               <span class='complience-degrees-icon'>
                  <degrees-icon />
               </span>
              {{$t('complience.stats.button.title')}}
            </template>
          </v-btn>
        </div>
      </div>
      <div>
        <el-radio-group v-model="activeCloudTab" size="small" class='tab-group'>
          <el-radio-button
            class="tab-button"
            v-for="tab in tabs"
            :label="tab.label"
            :key="tab.label"
          />
        </el-radio-group>
      </div>
      <div class='cloud-assets-tab__header__bottom'>
        <div class="select-all" v-if='isCloudBucketsTab || isCloudInstancesTab'>
          <CustomCheckbox
            :color="isIndeterminate ? 'pink' : 'cold-marine'"
            :value="itemsCount > 0"
            :indeterminate="isIndeterminate"
            size="s"
            @input="selectAll"
          />
          <div class="select-all__label">
            {{ `${itemsCount} ${selectAllLabel}` }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="!dataLoading && !cloudInstancesLoading && isCloudInstancesTab">
      <div v-if='cloudInstancesItemsPaged.length'>
        <assets-column-headers
          :display='true'
          :headers='headersForTab'
          tab='cloud'
        />
        <cloud-asset-row
          v-for="(cloudInstance, index) in cloudInstancesItemsPaged"
          :item="cloudInstance"
          tab="cloud"
          :key="index"
          :selected-items='selectedCloudItems'
          :excluded-items="excludedCloudItems"
          :is-all-selected="cloudIsAllSelected"
          :amountOfTestCardInRow='amountOfTestCardInRow'
          :add-test-card-disabled='isAddTestDisabled(cloudInstance)'
          @checked='checked'
          @initiateAction='initiateAction'
          @openAddTestPopup='openAddTestCardPopup(cloudInstance)'
        />
        <div class="cloud-assets-tab__pagination">
          <advanced-pagination
            tab='cloud'
            :page="pageCloud"
            :is-show-pagination='isShowPagination'
            :pages-amount='pages'
            @changedSelectedPage='changedSelectedPage'
            @changedItemsAmountPerPage='changedItemsAmountPerPage'
          />
        </div>
      </div>
      <no-data
        v-else
        :message='messageForNoData.toString()'
      />
    </div>
    <div v-else-if='!dataLoading && !cloudBucketsLoading  && isCloudBucketsTab'>
      <div v-if='s3BucketsItemsPaged.length'>
        <wombat-table
          :items="s3BucketsItemsPaged"
          :columns="tableColumnsBuckets"
          :name='bucketName'
          :resize="false"
          :loadingItems="true"
          :columnsReorder="false"
          :itemHeight="58"
          :noResultsMessage="$t('noResultsFound')"
        >
          <component
            slot="row-cell"
            slot-scope="rowCell"
            class="row-cell"
            :is="tableRowCellComponentsHashBuckets[rowCell.column.name] || tableRowCellComponentsHashBuckets.default"
            :item="rowCell.item"
            :column="rowCell.column"
            :selected-items='selectedBucketItems'
            :excluded-items="excludedBucketItems"
            :is-all-selected="bucketIsAllSelected"
            @checked='checked'
            @initiateAction='initiateAction'
          />
        </wombat-table>
        <div class="cloud-assets-tab__pagination">
          <advanced-pagination
            tab='bucket'
            :page="pageBucket"
            :pages-amount='pages'
            :is-show-pagination='isShowPagination'
            @changedSelectedPage='changedSelectedPage'
            @changedItemsAmountPerPage='changedItemsAmountPerPage'
          />
        </div>
      </div>
      <no-data
        v-else
        :message='messageForNoData.toString()'
      />
    </div>
    <div v-else-if='!dataLoading && !cloudServicesLoading && enableCloudComplianceFeature && isCloudComplianceTab' class='servicesTable'>
      <div v-if='cloudServicesItemsPaged.length'>
        <assets-column-headers
          :display='true'
          :headers='headersForServicesTab'
          tab='services'
          :clickable='true'
          :sortDirection='getSortDirection'
          :sortOption='getSortOption'
          :clickedHeaderValue="clickedHeaderValue"
          @headerClicked='headerClicked'
        />
        <cloud-services-asset-row
          v-for="(cloudService, index) in cloudServicesItemsPaged"
          :item="cloudService"
          tab="services"
          :key="index"
        />
        <div class="cloud-assets-tab__pagination">
          <advanced-pagination
            tab='services'
            :pages-amount='pages'
            :is-show-pagination='isShowPagination'
            :page='getServicesCurrentPage'
            @changedSelectedPage='changedSelectedPage'
            @changedItemsAmountPerPage='changedItemsAmountPerPage'
          />
        </div>
      </div>
      <no-data
        v-else
        :message='messageForNoData.toString()'
      />
    </div>
    <div v-else-if='!enableCloudComplianceFeature && isCloudComplianceTab'>
      <feature-toggle-disabled
      :title='"cloud.services.disabled.popup.header"'
      :message='"cloud.services.disabled.popup.message"'
      />
    </div>
    <div class='cloud-tab-loading' v-else />
    <page-loading-overlay
      v-if="isCloudInstancesTab"
      :show="cloudInstancesLoading && currentTab === 'cloud'"
      :progress="cloudInstancesProgress"
      contained
    />
    <page-loading-overlay
      v-else-if="isCloudBucketsTab"
      :show="cloudBucketsLoading && currentTab === 'cloud'"
      :progress="cloudBucketsProgress"
      contained
    />
    <page-loading-overlay
      v-else
      :show="cloudServicesLoading && currentTab === 'cloud' && enableCloudComplianceFeature"
      :progress="cloudServicesProgress"
      contained
    />
    <yes-no-popup
      class='suppress-assets-popup'
      :visible-popup="suppressAssetsPopup"
      :title="'cloud.assets.suppress.popup.title'"
      :message="'cloud.assets.suppress.popup.alert'"
      :no-caption="'confirm.cancel'"
      :yes-caption="'confirm.ok'"
      :loading="loadingSuppress"
      @clicked="suppressPopupClicked"
    />
    <yes-no-popup
      class='unsuppressed-assets-popup'
      :visible-popup="unsuppressedItemPopup"
      :title="'cloud.assets.unsuppressed.popup.title'"
      :message="'cloud.assets.unsuppressed.popup.alert'"
      :no-caption="'confirm.cancel'"
      :yes-caption="'confirm.ok'"
      :loading="loadingUnsuppressed"
      @clicked="unsuppressedPopupClicked"
    />
    <add-test-popup
      v-model="addTestCardPopup"
      :website="cloudAssetForTestCard"
      :tld="cloudAssetForTestCard.tld"
      :organization='cloudAssetForTestCard.organization'
      :tab="'cloud'"
      :testTypes="currentTestTypesForNewTest"
      @submit="addTestCard"
    />
    <compliance-statistic-popup
      :visible-popup='showStatsPopup'
      :stats='getComplianceStats'
      @clicked="showStatsPopup=false"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CLOUD_SERVICES_HEADERS, CONFIGURATION, CONFIGURATION_ACTION_TYPES } from '@/constants/configuration';
import WombatTable from '@/components/WombatTable/WombatTable.vue';
import WombatRowDefaultCell from '@/components/WombatTable/WombatRowDefaultCell.vue';
import FilteredSearch from '@/components/common/FilteredSearch.vue';
import {
  bucketsTabTableColumns,
} from '@/services/tableColumns';
import IntervalTableCell from '@/components/tableCells/cloudAssetsTableCells/IntervalTableCell.vue';
import BucketActionTableCell from '@/components/tableCells/bucketsTableCells/BucketActionTableCell.vue';
import BucketStatusTableCell from '@/components/tableCells/bucketsTableCells/BucketStatusTableCell.vue';
import AlertTableCell from '@/components/tableCells/cloudAssetsTableCells/AlertTableCell.vue';
import ActiveMonitoringTableCell from '@/components/tableCells/cloudAssetsTableCells/ActiveMonitoringTableCell.vue';
import CheckBoxTableCell from '@/components/tableCells/cloudAssetsTableCells/CheckBoxTableCell.vue';
import UrlTableCell from '@/components/tableCells/cloudAssetsTableCells/UrlTableCell.vue';
import PageLoadingOverlay from '@/components/common/PageLoadingOverlay.vue';
import { UPDATE_ITEMS_PER_PAGE } from '@/store/pagination/actionTypes';
import AdvancedPagination from '@/components/common/AdvancedPagination.vue';
import CustomCheckbox from '@/components/common/CustomCheckbox.vue';
import ActionsTableCell from '@/components/tableCells/cloudAssetsTableCells/ActionsTableCell.vue';
import YesNoPopup from '@/components/popup/YesNoPopup.vue';
import FeatureToggleDisabled from '@/components/common/FeatureToggleDisabled.vue';
import degreesIcon from '@/assets/icons/dergrees.svg?inline';
import {
  ADD_NEW_TEST_PROJECT,
  ADD_URL_CONFIGURATIONS,
  DELETE_CONFIGURATION, INITIATE_TEST_CARD,
  LOAD_TEST_CARDS_HOSTS,
  LOAD_TEST_CARDS_SUBDOMAINS,
  CHANGE_SERVICES_ASSETS_LIST_OPTIONS, LOAD_CLOUD_ACCOUNTS_FROM_CONFIGURATION,
} from '@/store/project/actionTypes';
import { LOAD_CLOUD_SERVICES_STATISTICS } from '@/store/statistics/actionTypes';
import {
  SET_CLOUD_BUCKETS_LOADING,
  SET_CLOUD_INSTANCES_LOADING,
  SET_CLOUD_SERVICES_LOADING,
  CHANGE_CLOUD_BUCKETS_LIST_OPTIONS,
  CHANGE_CLOUD_INSTANCES_LIST_OPTIONS, UPDATE_SELECTED_CLOUD_BUCKETS, UPDATE_SELECTED_CLOUD_INSTANCES,
} from '@/store/configuration/actionTypes';
import AddTestPopup from '@/components/popup/AddTestPopup.vue';
import NoData from '@/components/common/NoData.vue';
import { TEST_TYPES_CLOUD_ASSETS } from '@/constants/projects';
import AssetsColumnHeaders from '@/components/configuration/AssetsColumnHeaders.vue';
import CloudAssetRow from '@/components/configuration/CloudAssetRow.vue';
import CloudServicesAssetRow from '@/components/configuration/CloudServicesAssetRow.vue';
import ComplianceStatisticPopup from '@/components/popup/ComplianceStatisticPopup.vue';
import DownloadCSV from '@/assets/icons/download_csv.svg?inline';
import { downloadCSVReportByTab } from '@/services/repository';
import ConfigurationItemHeader from './ConfigurationItemHeader.vue';
import ConfigurationItemRow from './ConfigurationItemRow.vue';
import CustomTooltip from '../common/CustomTooltip.vue';

export default {
  name: 'CloudAssetsTab',
  components: {
    NoData,
    ComplianceStatisticPopup,
    AssetsColumnHeaders,
    CloudAssetRow,
    CloudServicesAssetRow,
    AddTestPopup,
    FilteredSearch,
    YesNoPopup,
    CustomCheckbox,
    AdvancedPagination,
    PageLoadingOverlay,
    CustomTooltip,
    ConfigurationItemRow,
    AlertTableCell,
    ConfigurationItemHeader,
    ActiveMonitoringTableCell,
    ActionsTableCell,
    CheckBoxTableCell,
    IntervalTableCell,
    BucketActionTableCell,
    BucketStatusTableCell,
    WombatTable,
    FeatureToggleDisabled,
    degreesIcon,
    DownloadCSV,
  },
  props: {
    amountOfTestCardInRow: {
      type: Number,
      default: 5,
      required: false,
    },
    enableCloudComplianceFeature: {
      type: Boolean,
      default: false,
      required: false,
    },
    currentTab: {
      required: false,
    },
  },
  data() {
    return {
      headersForTab: [
        'cloud.tab.url.header',
        'cloud.tab.ports.header',
        'cloud.tab.asset.type.header',
        'cloud.tab.status.header',
        'cloud.tab.last.scanned.date.header',
      ],
      headersForServicesTab: [
        'services.tab.service.name.header',
        'services.tab.resource.id.header',
        'services.tab.account.id.header',
        'services.tab.region.header',
        'services.tab.compliance.violation.header',
      ],
      tab: this.$route.params.tab || this.$t('configuration.cloud.assets.cloud.list'),
      exposedCloud: false,
      exposedBucket: false,
      showSuppressCloud: false,
      showSuppressBucket: false,
      searchCloud: '',
      searchBucket: '',
      searchServices: '',
      filterSearchCloud: [],
      filterFormattedCloud: [],
      filterSearchBucket: [],
      filterFormattedBucket: [],
      filterSearchServices: [],
      sortServices: {},
      clickedHeaderValue: {},
      servicesComplianceFilter: [],
      servicesRegionFilter: [],
      pageCloud: 1,
      pageBucket: 1,
      pageServices: 1,
      suppressAssetsPopup: false,
      unsuppressedItemPopup: false,
      itemToSuppress: null,
      itemToUnsuppressed: null,
      addTestCardPopup: false,
      cloudAssetForTestCard: {},
      currentTestTypesForNewTest: [TEST_TYPES_CLOUD_ASSETS.vuln_infra],
      showStatsPopup: false,
      cloudFiltersForPayload: {
        search: '',
        filter: {},
        toggles: {
          exposed: false,
          showSuppress: false,
        },
      },
      selectedCloudItems: [],
      excludedCloudItems: [],
      cloudIsAllSelected: false,
      bucketFiltersForPayload: {
        search: '',
        filter: {},
        toggles: {
          exposed: false,
          showSuppress: false,
        },
      },
      selectedBucketItems: [],
      excludedBucketItems: [],
      bucketIsAllSelected: false,
      loadingSuppress: false,
      loadingUnsuppressed: false,
      firstTimeCalled: false,
      pollingInstances: null,
      pollingBuckets: null,
      pollingServices: null,
      cloudLoading: false,
    };
  },
  async beforeDestroy() {
    clearInterval(this.pollingInstances);
    clearInterval(this.pollingBuckets);
    clearInterval(this.pollingServices);
  },
  computed: {
    ...mapGetters([
      'paginationItemsPerPageByTabs',
      'servicesAssetsPaginationState',
      'cloudServicesStatistics',
      'dataLoading',
      'cloudInstancesLoading',
      'cloudBucketsLoading',
      'cloudServicesLoading',
      'domains',
      'domainFilter',
      'configurationServicesAssets',
      'licenses',
      'amountOfRunningProjects',
      'configurationDomains',
      'companyData',
      'organizationFilter',
      'configurationCloudAccounts',
      'cloudInstancesPaginationState',
      'cloudInstancesItems',
      'cloudInstancesFullItems',
      'cloudBucketsPaginationState',
      'cloudBucketsItems',
      'cloudBucketsFullItems',
      'cloudInstancesRefId',
      'cloudBucketsRefId',
      'cloudServicesRefId',
      'cloudInstancesRunningInterval',
      'cloudBucketsRunningInterval',
      'cloudServicesRunningInterval',
      'cloudInstancesProgress',
      'cloudBucketsProgress',
      'cloudServicesProgress',
    ]),
    exposedValue: {
      get() {
        if (this.isCloudInstancesTab) {
          return this.exposedCloud;
        }
        return this.exposedBucket;
      },
      set() {
        if (this.isCloudInstancesTab) {
          this.exposedCloud = !this.exposedCloud;
        } else if (this.isCloudBucketsTab) {
          this.exposedBucket = !this.exposedBucket;
        }
      },
    },
    showSuppressValue: {
      get() {
        if (this.isCloudInstancesTab) {
          return this.showSuppressCloud;
        }
        return this.showSuppressBucket;
      },
      set() {
        if (this.isCloudInstancesTab) {
          this.showSuppressCloud = !this.showSuppressCloud;
          this.selectedCloudItems = [];
          this.excludedCloudItems = [];
          this.cloudIsAllSelected = false;
          this.cloudFiltersForPayload = {
            search: '',
            filter: {},
            toggles: {
              exposed: false,
              showSuppress: false,
            },
          };
        } else if (this.isCloudBucketsTab) {
          this.showSuppressBucket = !this.showSuppressBucket;
          this.selectedBucketItems = [];
          this.excludedBucketItems = [];
          this.bucketIsAllSelected = false;
          this.bucketFiltersForPayload = {
            search: '',
            filter: {},
            toggles: {
              exposed: false,
              showSuppress: false,
            },
          };
        }
      },
    },
    messageForNoData() {
      // eslint-disable-next-line no-nested-ternary
      return this.organizationFilter.length && this.domainFilter.length && this.domainFilter.some(asset => this.configurationCloudAccounts.find(cloud => cloud.configData === asset))
        // eslint-disable-next-line no-nested-ternary
        ? (this.isCloudInstancesTab ? this.$t('cloud.assets.no.data.message') : (this.isCloudBucketsTab ? this.$t('buckets.no.data.message') : this.$t('services.no.data.message')))
        : this.$t('no.filter.cloud.no.data.message');
    },
    getComplianceStats() {
      return this.cloudServicesStatistics || {};
    },
    filtersCloud() {
      return [{name: 'Port', attr: 'port'}, {name: 'Provider', attr: 'provider'}, {name: 'Last Scanned Date', attr: 'lastScannedDate'}];
    },
    filtersBucket() {
      return [{name: 'Provider', attr: 'provider'}];
    },
    filtersServices() {
      return [{name: 'Region', attr: 'region'}, {name: 'Select Compliance', attr: 'selectCompliance'}];
    },
    suppressedToggleLabel() {
      return (this.showSuppressCloud || this.showSuppressBucket) ? this.$t('configuration.results.assets.list') : this.$t('configuration.suppressed.assets.list');
    },
    itemsCount() {
      if (this.isCloudInstancesTab) {
        if (this.cloudIsAllSelected) {
          return (this.cloudFiltersForPayload.total - this.excludedCloudItems.length + this.selectedCloudItems.length);
        }
        return this.selectedCloudItems.length || 0;
      }
      if (this.bucketIsAllSelected) {
        return (this.bucketFiltersForPayload.total - this.excludedBucketItems.length + this.selectedBucketItems.length);
      }
      return this.selectedBucketItems.length || 0;
    },
    selectAllLabel() {
      return this.$t('configuration.infrastructure.assets.selected.assets');
    },
    isIndeterminate() {
      if (this.isCloudInstancesTab) {
        return this.selectedCloudItems.length !== this.cloudInstancesPaginationState.total && !this.cloudIsAllSelected;
      }
      return this.selectedBucketItems.length !== this.cloudBucketsPaginationState.total && !this.bucketIsAllSelected;
    },
    cloudItemsPerPage() {
      return this.paginationItemsPerPageByTabs.cloud;
    },
    bucketItemsPerPage() {
      return this.paginationItemsPerPageByTabs.bucket;
    },
    servicesItemsPerPage() {
      return this.paginationItemsPerPageByTabs.services;
    },
    isSuppressAssetDisabled() {
      if (this.isCloudInstancesTab) {
        return !this.selectedCloudItems.length && !this.cloudIsAllSelected;
      }
      return !this.selectedBucketItems.length && !this.bucketIsAllSelected;
    },
    isComplianceStatsDisabled() {
      return this.cloudServicesStatistics ? Object.keys(this.cloudServicesStatistics).length <= 0 : true;
    },
    isDownloadCsvDisabled() {
      if (this.isCloudInstancesTab) {
        return this.dataLoading || this.cloudInstancesLoading;
      }
      return this.dataLoading || this.cloudBucketsLoading;
    },
    toggleSuppressButtonLabel() {
      if (this.isCloudInstancesTab) {
        return this.showSuppressCloud ? this.$t('configuration.unsuppressed.assets') : this.$t('configuration.suppress.assets');
      }
      return this.showSuppressBucket ? this.$t('configuration.unsuppressed.assets') : this.$t('configuration.suppress.assets');
    },
    tableColumnsBuckets() {
      const columns = [
        bucketsTabTableColumns.select,
        bucketsTabTableColumns.actions,
        bucketsTabTableColumns.url,
        bucketsTabTableColumns.status,
        /* [CYN-271] Removed until the UX/UI design will be finally closed
           bucketsTabTableColumns.action,
         */
      ].filter(column => column)
        .map(column => ({
          ...column,
          title: column.title && this.$t((`configuration.cloud.${column.title.toString().replace(' ', '.')}`).toString()),
        }));
      return [...columns];
    },
    tableRowCellComponentsHashBuckets() {
      return {
        actions: ActionsTableCell,
        select: CheckBoxTableCell,
        url: UrlTableCell,
        status: BucketStatusTableCell,
        default: WombatRowDefaultCell,
      };
    },
    bucketName() {
      return 'buckets-table';
    },
    cloudInstancesItemsPaged() {
      return this.cloudInstancesItems;
    },
    s3BucketsItemsPaged() {
      return this.cloudBucketsItems.map((item, index) => ({id: index, ...item}));
    },
    cloudServicesItemsPaged() {
      const services = this.configurationServicesAssets;
      return services;
    },
    getServicesCurrentPage() {
      return this.servicesAssetsPaginationState.page;
    },
    cloudInstances() {
      return {
        label: this.$t('configuration.cloud.assets.cloud.list'),
      };
    },
    buckets() {
      return {
        label: this.$t('configuration.cloud.assets.buckets.list'),
      };
    },
    cloudCompliance() {
      return {
        label: this.$t('configuration.cloud.assets.compliance.list'),
      };
    },
    severityToSortingScore() {
      return {
        critical: 10000,
        high: 1000,
        medium: 100,
        low: 10,
      };
    },
    tabs() {
      return [this.cloudInstances, this.buckets, this.cloudCompliance];
    },
    activeCloudTab: {
      set(tab) {
        this.tab = tab;
      },
      get() {
        return this.tab;
      },
    },
    isCloudInstancesTab() {
      return this.activeCloudTab === this.cloudInstances.label;
    },
    isCloudBucketsTab() {
      return this.activeCloudTab === this.buckets.label;
    },
    isCloudComplianceTab() {
      return this.activeCloudTab === this.cloudCompliance.label;
    },
    warningTooltip() {
      return this.$t('configuration.infrastructure.assets.tooltip');
    },
    pages() {
      if (this.isCloudInstancesTab) {
        return this.cloudInstancesPaginationState?.pageCount || Math.ceil(this.cloudInstancesItems.length / this.cloudItemsPerPage);
      } if (this.isCloudBucketsTab) {
        return this.cloudBucketsPaginationState?.pageCount || Math.ceil(this.s3BucketsItemsPaged.length / this.bucketItemsPerPage);
      }
      return this.servicesAssetsPaginationState?.pageCount || Math.ceil(this.servicesAssetsPaginationState?.total / this.servicesItemsPerPage);
    },
    isShowPagination() {
      return this.pages > 1;
    },
    getSortDirection() {
      return Object.values(this.sortServices)?.includes('desc') ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
    },
    getSortOption() {
      return this.headersForServicesTab.filter(header => Object.keys(this.sortServices)[0] === CLOUD_SERVICES_HEADERS[header])[0] || '';
    },
  },
  watch: {
    async currentTab() {
      if (this.currentTab === 'cloud' && this.domainFilter.length && !this.firstTimeCalled) {
        this.firstTimeCalled = true;
        await this.setLoadingForTabs();
        this.loadCloudInstances().then();
        this.loadCloudBuckets().then();
        if (this.enableCloudComplianceFeature) {
          this.loadServicesAssets().then();
        }
        await this.$store.dispatch(LOAD_TEST_CARDS_SUBDOMAINS);
      }
      this.resetSelectedItems();
    },
    async domainFilter() {
      this.resetSelectedItems();
      if (this.currentTab !== 'cloud' && this.domainFilter.length) {
        this.firstTimeCalled = false;
      }
      if (this.currentTab === 'cloud' && this.domainFilter.length) {
        this.pageCloud = 1;
        this.pageBucket = 1;
        this.pageServices = 1;
        this.searchCloud = '';
        this.searchServices = '';
        this.searchBucket = '';
        await this.setLoadingForTabs();
        this.loadCloudInstances().then();
        this.loadCloudBuckets().then();
        if (this.enableCloudComplianceFeature) {
          this.loadServicesAssets().then();
        }
        await this.$store.dispatch(LOAD_TEST_CARDS_SUBDOMAINS);
      }
    },
    async exposedCloud() {
      this.pageCloud = 1;
      await this.loadCloudInstances();
    },
    async showSuppressCloud() {
      this.pageCloud = 1;
      await this.loadCloudInstances();
    },
    async searchCloud() {
      this.pageCloud = 1;
      await this.loadCloudInstances();
    },
    async filterFormattedCloud() {
      this.pageCloud = 1;
      await this.loadCloudInstances();
    },
    async exposedBucket() {
      this.pageBucket = 1;
      await this.loadCloudBuckets();
    },
    async showSuppressBucket() {
      this.pageBucket = 1;
      await this.loadCloudBuckets();
    },
    async searchBucket() {
      this.pageBucket = 1;
      await this.loadCloudBuckets();
    },
    async filterFormattedBucket() {
      this.pageBucket = 1;
      await this.loadCloudBuckets();
    },
    async sortServices() {
      this.pageServices = 1;
      await this.loadServicesAssets();
    },
    async searchServices() {
      this.pageServices = 1;
      await this.loadServicesAssets();
    },
    async filterSearchServices() {
      this.pageServices = 1;
      await this.parseServicesFilters();
      await this.loadServicesAssets();
    },
    async pageServices() {
      await this.loadServicesAssets();
    },
    async servicesItemsPerPage() {
      await this.loadServicesAssets();
    },
    excludedCloudItems() {
      if (this.excludedCloudItems.length === this.cloudFiltersForPayload.total && this.cloudIsAllSelected) {
        this.cloudIsAllSelected = false;
      }
    },
    selectedCloudItems() {
      if (this.selectedCloudItems.length === this.cloudFiltersForPayload.total && !this.cloudIsAllSelected) {
        this.cloudIsAllSelected = true;
      }
    },
    async cloudIsAllSelected() {
      if (!this.cloudIsAllSelected) {
        this.excludedCloudItems = [];
        this.resetCloudFiltersForPayload();
      }
      if (this.cloudIsAllSelected) {
        const items = [];
        this.cloudInstancesItems.forEach(item => {
          items.push({ ...item, selected: true });
        });
        await this.$store.dispatch(UPDATE_SELECTED_CLOUD_INSTANCES, items);
        this.selectedCloudItems = [];
        this.resetCloudFiltersForPayload();
      }
    },
    excludedBucketItems() {
      if (this.excludedBucketItems.length === this.bucketFiltersForPayload.total && this.bucketIsAllSelected) {
        this.bucketIsAllSelected = false;
      }
    },
    selectedBucketItems() {
      if (this.selectedBucketItems.length === this.bucketFiltersForPayload.total && !this.bucketIsAllSelected) {
        this.bucketIsAllSelected = true;
      }
    },
    async bucketIsAllSelected() {
      if (!this.bucketIsAllSelected) {
        this.excludedBucketItems = [];
        this.resetBucketFiltersForPayload();
      }
      if (this.bucketIsAllSelected) {
        const items = [];
        this.cloudBucketsItems.forEach(item => {
          items.push({ ...item, selected: true });
        });
        await this.$store.dispatch(UPDATE_SELECTED_CLOUD_BUCKETS, items);
        this.selectedBucketItems = [];
        this.resetBucketFiltersForPayload();
      }
    },
  },
  methods: {
    async loadCloudInstances() {
      if (this.currentTab === 'cloud' && this.domainFilter.length > 0) {
        clearInterval(this.pollingInstances);
        let turnOnLoading = false;
        if (this.isCloudInstancesTab) {
          turnOnLoading = true;
        }
        await this.$store.dispatch(CHANGE_CLOUD_INSTANCES_LIST_OPTIONS, {
          sort: {
            default: 'asc',
          },
          limit: this.cloudItemsPerPage,
          page: this.pageCloud,
          search: this.searchCloud,
          filter: this.filterFormattedCloud,
          exposed: this.exposedCloud,
          showSuppress: this.showSuppressCloud,
          domain: this.domainFilter || [],
          organizations: this.organizationFilter || [],
          turnOnLoading,
          tab: 'cloudInstances',
          selectAllFilters: {
            ...this.cloudFiltersForPayload, selected: this.selectedCloudItems, excluded: this.excludedCloudItems, isAllSelected: this.cloudIsAllSelected,
          },
        });
        if (this.cloudInstancesRefId && this.cloudInstancesRefId !== '') {
          this.pollingInstances = setInterval(async () => {
            if (!this.cloudInstancesRefId || this.cloudInstancesRefId === '') {
              clearInterval(this.pollingInstances);
            } else if (!this.cloudInstancesRunningInterval) {
              await this.$store.dispatch(CHANGE_CLOUD_INSTANCES_LIST_OPTIONS, {
                sort: {
                  default: 'asc',
                },
                limit: this.cloudItemsPerPage,
                page: this.pageCloud,
                search: this.searchCloud,
                filter: this.filterFormattedCloud,
                exposed: this.exposedCloud,
                showSuppress: this.showSuppressCloud,
                domain: this.domainFilter || [],
                organizations: this.organizationFilter || [],
                turnOnLoading,
                tab: 'cloudInstances',
                refId: this.cloudInstancesRefId,
                selectAllFilters: {
                  ...this.cloudFiltersForPayload, selected: this.selectedCloudItems, excluded: this.excludedCloudItems, isAllSelected: this.cloudIsAllSelected,
                },
              });
            }
          }, 3000);
        }
      }
    },
    async loadCloudBuckets() {
      if (this.currentTab === 'cloud' && this.domainFilter.length) {
        clearInterval(this.pollingBuckets);
        let turnOnLoading = false;
        if (this.isCloudBucketsTab) {
          turnOnLoading = true;
        }
        await this.$store.dispatch(CHANGE_CLOUD_BUCKETS_LIST_OPTIONS, {
          sort: {
            default: 'asc',
          },
          limit: this.bucketItemsPerPage,
          page: this.pageBucket,
          search: this.searchBucket,
          filter: this.filterFormattedBucket,
          exposed: this.exposedBucket,
          showSuppress: this.showSuppressBucket,
          domain: this.domainFilter || [],
          organizations: this.organizationFilter || [],
          turnOnLoading,
          tab: 'cloudBuckets',
          selectAllFilters: {
            ...this.bucketFiltersForPayload, selected: this.selectedBucketItems, excluded: this.excludedBucketItems, isAllSelected: this.bucketIsAllSelected,
          },
        });
        if (this.cloudBucketsRefId && this.cloudBucketsRefId !== '') {
          this.pollingBuckets = setInterval(async () => {
            if (!this.cloudBucketsRefId || this.cloudBucketsRefId === '') {
              clearInterval(this.pollingBuckets);
            } else if (!this.cloudBucketsRunningInterval) {
              await this.$store.dispatch(CHANGE_CLOUD_BUCKETS_LIST_OPTIONS, {
                sort: {
                  default: 'asc',
                },
                limit: this.bucketItemsPerPage,
                page: this.pageBucket,
                search: this.searchBucket,
                filter: this.filterFormattedBucket,
                exposed: this.exposedBucket,
                showSuppress: this.showSuppressBucket,
                domain: this.domainFilter || [],
                organizations: this.organizationFilter || [],
                turnOnLoading,
                tab: 'cloudBuckets',
                refId: this.cloudBucketsRefId,
                selectAllFilters: {
                  ...this.bucketFiltersForPayload, selected: this.selectedBucketItems, excluded: this.excludedBucketItems, isAllSelected: this.bucketIsAllSelected,
                },
              });
            }
          }, 3000);
        }
      }
    },
    async loadServicesAssets() {
      if (this.currentTab === 'cloud' && this.domainFilter.length) {
        clearInterval(this.pollingServices);
        if (this.enableCloudComplianceFeature) {
          let turnOnLoading = false;
          if (this.isCloudComplianceTab) {
            turnOnLoading = true;
          }
          await this.$store.dispatch(CHANGE_SERVICES_ASSETS_LIST_OPTIONS, {
            domain: this.domainFilter,
            limit: this.servicesItemsPerPage,
            search: this.searchServices,
            page: this.pageServices,
            sort: this.sortServices,
            complianceItems: this.servicesComplianceFilter,
            regions: this.servicesRegionFilter,
            turnOnLoading,
          });
          await this.$store.dispatch(LOAD_CLOUD_SERVICES_STATISTICS, {
            domain: this.domainFilter,
            filter: ['cloud_compliance.cloudCompliance'],
          });
        }
        if (this.cloudServicesRefId && this.cloudServicesRefId !== '') {
          this.pollingServices = setInterval(async () => {
            if (!this.cloudServicesRefId || this.cloudServicesRefId === '') {
              clearInterval(this.pollingServices);
            } else if (!this.cloudServicesRunningInterval) {
              if (this.enableCloudComplianceFeature) {
                let turnOnLoading = false;
                if (this.isCloudComplianceTab) {
                  turnOnLoading = true;
                }
                await this.$store.dispatch(CHANGE_SERVICES_ASSETS_LIST_OPTIONS, {
                  domain: this.domainFilter,
                  limit: this.servicesItemsPerPage,
                  search: this.searchServices,
                  page: this.pageServices,
                  sort: this.sortServices,
                  complianceItems: this.servicesComplianceFilter,
                  regions: this.servicesRegionFilter,
                  turnOnLoading,
                  refId: this.cloudServicesRefId,
                });
              }
            }
          }, 3000);
        }
      }
    },
    async setLoadingForTabs() {
      await this.$store.dispatch(SET_CLOUD_INSTANCES_LOADING, true);
      await this.$store.dispatch(SET_CLOUD_BUCKETS_LOADING, true);
      // Only flag the services tab as loading when the compliance feature is
      // licensed. Otherwise loadServicesAssets is skipped and the flag would
      // never be cleared, leaving a stuck loading overlay on the tab.
      await this.$store.dispatch(SET_CLOUD_SERVICES_LOADING, this.enableCloudComplianceFeature);
    },
    resetSelectedItems() {
      this.selectedCloudItems = [];
      this.excludedCloudItems = [];
      this.cloudIsAllSelected = false;
      this.cloudFiltersForPayload = {
        search: '',
        filter: {},
        toggles: {
          exposed: false,
          showSuppress: false,
        },
      };
      this.selectedBucketItems = [];
      this.excludedBucketItems = [];
      this.bucketIsAllSelected = false;
      this.bucketFiltersForPayload = {
        search: '',
        filter: {},
        toggles: {
          exposed: false,
          showSuppress: false,
        },
      };
    },
    resetCloudFiltersForPayload() {
      this.cloudFiltersForPayload = {
        search: this.searchCloud,
        filter: this.filterSearchCloud,
        toggles: {
          exposed: this.exposedCloud,
          showSuppress: this.showSuppressCloud,
        },
        total: this.cloudInstancesPaginationState.total,
      };
    },
    resetBucketFiltersForPayload() {
      this.bucketFiltersForPayload = {
        search: this.searchBucket,
        filter: this.filterSearchBucket,
        toggles: {
          exposed: this.exposedBucket,
          showSuppress: this.showSuppressBucket,
        },
        total: this.cloudBucketsPaginationState.total,
      };
    },
    isAddTestDisabled(item) {
      const itemTld = item.tld;
      const companyName = this.configurationDomains.find(manualConfItem => manualConfItem.tld === itemTld)?.organization.name || this.companyData.name;
      return !this.licenses[companyName]?.length && this.amountOfRunningProjects[companyName] > 2;
    },
    async parseServicesFilters() {
      const filterMap = this.extractFiltersServices();
      this.servicesComplianceFilter = filterMap.get('compliance') || [];
      this.servicesRegionFilter = filterMap.get('region') || [];
    },
    async addTestCard(test) {
      if (this.cloudAssetForTestCard.status === CONFIGURATION.CLOUD_STATUS.exposed) {
        const testWithTld = test;
        testWithTld.tld = this.cloudAssetForTestCard.tld;
        testWithTld.metaData = {
          ...testWithTld.metaData,
          assetType: CONFIGURATION.CONFIG_TYPES.CLOUD_ASSET,
        };
        try {
          const createdTest = await this.$store.dispatch(ADD_NEW_TEST_PROJECT, testWithTld);
          if (!testWithTld.schedule && createdTest) {
            await this.$store.dispatch(INITIATE_TEST_CARD, [createdTest.id]);
          }
        } catch (e) {
          this.errorText = e.message;
        }
        await this.$store.dispatch(LOAD_TEST_CARDS_HOSTS);
        await this.$store.dispatch(LOAD_TEST_CARDS_SUBDOMAINS);
      }
    },
    headerClicked(payload) {
      const sortDirection = payload.clicks % 2 === 0 ? 'asc' : 'desc';
      const sortBy = CLOUD_SERVICES_HEADERS[payload.header];
      this.sortServices = {
        [sortBy]: sortDirection,
      };
      this.clickedHeaderValue = {
        [payload.header]: payload.clicks,
      };
    },
    async statsClicked() {
      await this.$store.dispatch(LOAD_CLOUD_ACCOUNTS_FROM_CONFIGURATION);
      this.showStatsPopup = true;
    },
    extractSearchString(search) {
      if (!search) {
        return '';
      }
      let results = search.split(' ');
      results = results.filter(result => !result.includes(':'));
      return results.join(' ').trim();
    },
    extractFilters(search, filterItem) {
      const filtersMap = new Map();
      if (search) {
        let results = search.split(' ');
        results = results.filter(result => result.includes(':'));
        results.forEach(item => {
          const filter = item.split(':');
          if (filter.length > 1 && filter[1].length > 0) {
            filtersMap.set(filter[0], filter[1].split(',').map(element => element.trim()));
          }
        });
      }
      if (filterItem.length > 0) {
        filterItem.forEach(item => {
          const filter = item.split(':');
          if (filtersMap.has(filter[0])) {
            const filtersValues = filtersMap.get(filter[0]);
            filter[1].split(',').forEach(value => {
              filtersValues.push(value.trim());
            });
            filtersMap.set(filter[0], filtersValues);
          } else {
            const filtersValues = [];
            filter[1].split(',').forEach(value => {
              filtersValues.push(value.trim());
            });
            filtersMap.set(filter[0], filtersValues);
          }
        });
      }
      return filtersMap;
    },
    extractFiltersCloud() {
      return this.extractFilters(this.searchCloud, this.filterSearchCloud);
    },
    extractFiltersBucket() {
      return this.extractFilters(this.searchBucket, this.filterSearchBucket);
    },
    extractFiltersServices() {
      return this.extractFilters(this.searchServices, this.filterSearchServices);
    },
    async suppressPopupClicked(value) {
      this.loadingSuppress = true;
      if (value) {
        if (this.itemToSuppress) {
          await this.suppressItem();
        } else {
          await this.suppressItems();
        }
      } else {
        this.suppressAssetsPopup = false;
      }
      this.loadingSuppress = false;
    },
    async unsuppressedPopupClicked(value) {
      this.loadingUnsuppressed = true;
      if (value) {
        if (this.itemToUnsuppressed) {
          await this.unsuppressedItem();
        } else {
          await this.unsuppressedItems();
        }
      } else {
        this.unsuppressedItemPopup = false;
      }
      this.loadingUnsuppressed = false;
    },
    async suppressItems() {
      let configData = {};
      if (this.isCloudInstancesTab) {
        configData = {
          selected: this.selectedCloudItems,
          excluded: this.excludedCloudItems,
          search: this.cloudFiltersForPayload?.search || '',
          filter: Object.keys(this?.cloudFiltersForPayload)?.length ? JSON.stringify(Object.fromEntries(this.cloudFiltersForPayload?.filter)) : {},
          toggles: {
            exposed: this.cloudFiltersForPayload?.toggles?.exposed || false,
            showSuppress: this.cloudFiltersForPayload?.toggles?.showSuppress || false,
          },
          isAllSelected: this.cloudIsAllSelected,
          domain: this.domainFilter || [],
          organizations: this.organizationFilter || [],
          tab: 'cloudInstances',
        };
      } else if (this.isCloudBucketsTab) {
        configData = {
          selected: this.selectedBucketItems,
          excluded: this.excludedBucketItems,
          search: this.bucketFiltersForPayload?.search || '',
          filter: Object.keys(this?.bucketFiltersForPayload)?.length ? JSON.stringify(Object.fromEntries(this.bucketFiltersForPayload?.filter)) : {},
          toggles: {
            exposed: this.bucketFiltersForPayload?.toggles?.exposed || false,
            showSuppress: this.bucketFiltersForPayload?.toggles?.showSuppress || false,
          },
          isAllSelected: this.bucketIsAllSelected,
          domain: this.domainFilter || [],
          organizations: this.organizationFilter || [],
          tab: 'cloudBuckets',
        };
      }
      await this.$store.dispatch(ADD_URL_CONFIGURATIONS, {
        payload: configData,
        configType: this.isCloudInstancesTab ? CONFIGURATION.CONFIG_TYPES.CLOUD_ASSET : CONFIGURATION.CONFIG_TYPES.BUCKET_ASSET,
        successMessageType: this.isCloudInstancesTab ? CONFIGURATION_ACTION_TYPES.SUPPRESS_CLOUD_ASSET : CONFIGURATION_ACTION_TYPES.SUPPRESS_CLOUD_BUCKET,
      });
      this.suppressAssetsPopup = false;
      if (this.isCloudInstancesTab) {
        this.selectedCloudItems = [];
        this.excludedCloudItems = [];
        this.cloudIsAllSelected = false;
        this.pageCloud = 1;
        this.resetCloudFiltersForPayload();
        await this.loadCloudInstances();
      } else if (this.isCloudBucketsTab) {
        this.selectedBucketItems = [];
        this.excludedBucketItems = [];
        this.bucketIsAllSelected = false;
        this.pageBucket = 1;
        this.resetBucketFiltersForPayload();
        await this.loadCloudBuckets();
      }
    },
    async suppressItem() {
      await this.$store.dispatch(ADD_URL_CONFIGURATIONS, {
        payload: [{ data: this.itemToSuppress.url, metaData: [], tld: this.itemToSuppress.tld }],
        configType: this.isCloudInstancesTab ? CONFIGURATION.CONFIG_TYPES.CLOUD_ASSET : CONFIGURATION.CONFIG_TYPES.BUCKET_ASSET,
        successMessageType: this.isCloudInstancesTab ? CONFIGURATION_ACTION_TYPES.SUPPRESS_CLOUD_ASSET : CONFIGURATION_ACTION_TYPES.SUPPRESS_CLOUD_BUCKET,
      });
      this.itemToSuppress = null;
      this.suppressAssetsPopup = false;
      if (this.isCloudInstancesTab) {
        this.selectedCloudItems = [];
        this.excludedCloudItems = [];
        this.cloudIsAllSelected = false;
        this.pageCloud = 1;
        this.resetCloudFiltersForPayload();
        await this.loadCloudInstances();
      } else if (this.isCloudBucketsTab) {
        this.selectedBucketItems = [];
        this.excludedBucketItems = [];
        this.bucketIsAllSelected = false;
        this.pageBucket = 1;
        this.resetBucketFiltersForPayload();
        await this.loadCloudBuckets();
      }
    },
    async unsuppressedItem() {
      await this.$store.dispatch(DELETE_CONFIGURATION, {
        payload: [{ data: this.itemToUnsuppressed.url, metaData: [], tld: this.itemToUnsuppressed.tld }],
        configType: this.isCloudInstancesTab ? CONFIGURATION.CONFIG_TYPES.CLOUD_ASSET : CONFIGURATION.CONFIG_TYPES.BUCKET_ASSET,
        successMessageType: this.isCloudInstancesTab ? CONFIGURATION_ACTION_TYPES.ENABLE_CLOUD_ASSET : CONFIGURATION_ACTION_TYPES.ENABLE_CLOUD_BUCKET,
      });
      this.itemToUnsuppressed = null;
      this.unsuppressedItemPopup = false;
      if (this.isCloudInstancesTab) {
        this.selectedCloudItems = [];
        this.excludedCloudItems = [];
        this.cloudIsAllSelected = false;
        this.pageCloud = 1;
        this.resetCloudFiltersForPayload();
        await this.loadCloudInstances();
      } else if (this.isCloudBucketsTab) {
        this.selectedBucketItems = [];
        this.excludedBucketItems = [];
        this.bucketIsAllSelected = false;
        this.pageBucket = 1;
        this.resetBucketFiltersForPayload();
        await this.loadCloudBuckets();
      }
    },
    async unsuppressedItems() {
      let configData = {};
      if (this.isCloudInstancesTab) {
        configData = {
          selected: this.selectedCloudItems,
          excluded: this.excludedCloudItems,
          search: this.cloudFiltersForPayload?.search || '',
          filter: Object.keys(this?.cloudFiltersForPayload)?.length ? JSON.stringify(Object.fromEntries(this.cloudFiltersForPayload?.filter)) : {},
          toggles: {
            exposed: this.cloudFiltersForPayload?.toggles?.exposed || false,
            showSuppress: this.cloudFiltersForPayload?.toggles?.showSuppress || true,
          },
          isAllSelected: this.cloudIsAllSelected,
          domain: this.domainFilter || [],
          organizations: this.organizationFilter || [],
          tab: 'cloudInstances',
        };
      } else if (this.isCloudBucketsTab) {
        configData = {
          selected: this.selectedBucketItems,
          excluded: this.excludedBucketItems,
          search: this.bucketFiltersForPayload?.search || '',
          filter: Object.keys(this?.bucketFiltersForPayload)?.length ? JSON.stringify(Object.fromEntries(this.bucketFiltersForPayload?.filter)) : {},
          toggles: {
            exposed: this.bucketFiltersForPayload?.toggles?.exposed || false,
            showSuppress: this.bucketFiltersForPayload?.toggles?.showSuppress || false,
          },
          isAllSelected: this.bucketIsAllSelected,
          domain: this.domainFilter || [],
          organizations: this.organizationFilter || [],
          tab: 'cloudBuckets',
        };
      }
      await this.$store.dispatch(DELETE_CONFIGURATION, {
        payload: configData,
        configType: this.isCloudInstancesTab ? CONFIGURATION.CONFIG_TYPES.CLOUD_ASSET : CONFIGURATION.CONFIG_TYPES.BUCKET_ASSET,
        successMessageType: this.isCloudInstancesTab ? CONFIGURATION_ACTION_TYPES.ENABLE_CLOUD_ASSET : CONFIGURATION_ACTION_TYPES.ENABLE_CLOUD_BUCKET,
      });
      this.unsuppressedItemPopup = false;
      if (this.isCloudInstancesTab) {
        this.selectedCloudItems = [];
        this.excludedCloudItems = [];
        this.cloudIsAllSelected = false;
        this.pageCloud = 1;
        this.resetCloudFiltersForPayload();
        await this.loadCloudInstances();
      } else if (this.isCloudBucketsTab) {
        this.selectedBucketItems = [];
        this.excludedBucketItems = [];
        this.bucketIsAllSelected = false;
        this.pageBucket = 1;
        this.resetBucketFiltersForPayload();
        await this.loadCloudBuckets();
      }
    },
    toggleSuppressAssetsClicked() {
      if (this.isCloudInstancesTab) {
        if (this.showSuppressCloud) {
          this.unsuppressedItemPopup = true;
        } else {
          this.suppressAssetsPopup = true;
        }
      } else if (this.isCloudBucketsTab) {
        if (this.showSuppressBucket) {
          this.unsuppressedItemPopup = true;
        } else {
          this.suppressAssetsPopup = true;
        }
      }
    },
    selectAll() {
      if (this.isCloudInstancesTab) {
        this.cloudIsAllSelected = !this.cloudIsAllSelected;
        if (this.selectedCloudItems.length) {
          this.selectedCloudItems = [];
        }
        if (this.excludedCloudItems.length) {
          this.excludedCloudItems = [];
        }
        this.resetCloudFiltersForPayload();
      } else {
        this.bucketIsAllSelected = !this.bucketIsAllSelected;
        if (this.selectedBucketItems.length) {
          this.selectedBucketItems = [];
        }
        if (this.excludedBucketItems.length) {
          this.excludedBucketItems = [];
        }
        this.resetBucketFiltersForPayload();
      }
    },
    async changedItemsAmountPerPage(itemsPerPage) {
      window.scrollTo(0, 0);
      let tab = 'services';
      if (this.isCloudInstancesTab) {
        tab = 'cloud';
      } else if (this.isCloudBucketsTab) {
        tab = 'bucket';
      }
      await this.$store.dispatch(UPDATE_ITEMS_PER_PAGE, { itemsPerPage, tab });
      if (this.isCloudInstancesTab) {
        this.pageCloud = 1;
        await this.loadCloudInstances();
      } else if (this.isCloudBucketsTab) {
        this.pageBucket = 1;
        await this.loadCloudBuckets();
      } else {
        this.pageServices = 1;
      }
    },
    async changedSelectedPage(currentPage) {
      window.scrollTo(0, 0);
      if (this.isCloudInstancesTab) {
        this.pageCloud = currentPage;
        await this.loadCloudInstances();
      } else if (this.isCloudBucketsTab) {
        this.pageBucket = currentPage;
        await this.loadCloudBuckets();
      } else {
        this.pageServices = currentPage;
      }
    },
    checked(item) {
      if (this.isCloudInstancesTab) {
        if (this.cloudIsAllSelected) {
          if (item?.selected !== undefined) {
            if (item.selected) {
              const index = this.excludedCloudItems.findIndex(instance => instance.split('_')[0] === item.url && instance.split('_')[1] === item.tld);
              if (index !== -1) {
                this.excludedCloudItems.splice(index, 1);
              } else {
                this.excludedCloudItems.push(`${item.url}_${item.tld}`);
              }
            } else {
              const index = this.selectedCloudItems.findIndex(instance => instance.split('_')[0] === item.url && instance.split('_')[1] === item.tld);
              if (index !== -1) {
                this.selectedCloudItems.splice(index, 1);
              } else {
                this.selectedCloudItems.push(`${item.url}_${item.tld}`);
              }
              if (this.excludedCloudItems.includes(`${item.url}_${item.tld}`)) {
                const excludeIndex = this.excludedCloudItems.findIndex(data => data === data.split('_')[0] === item.url && data.split('_')[1] === item.tld);
                this.excludedCloudItems.splice(excludeIndex, 1);
                this.cloudFiltersForPayload.total -= 1;
              }
            }
          } else {
            const index = this.excludedCloudItems.findIndex(instance => instance.split('_')[0] === item.url && instance.split('_')[1] === item.tld);
            if (index !== -1) {
              this.excludedCloudItems.splice(index, 1);
            } else {
              this.excludedCloudItems.push(`${item.url}_${item.tld}`);
            }
          }
        } else {
          const index = this.selectedCloudItems.findIndex(instance => instance.split('_')[0] === item.url && instance.split('_')[1] === item.tld);
          if (index !== -1) {
            this.selectedCloudItems.splice(index, 1);
          } else {
            this.selectedCloudItems.push(`${item.url}_${item.tld}`);
          }
        }
      } else if (this.isCloudBucketsTab) {
        if (this.bucketIsAllSelected) {
          if (item?.selected !== undefined) {
            if (item.selected) {
              const index = this.excludedBucketItems.findIndex(instance => instance === item.url);
              if (index !== -1) {
                this.excludedBucketItems.splice(index, 1);
              } else {
                this.excludedBucketItems.push(item.url);
              }
            } else {
              const index = this.selectedBucketItems.findIndex(instance => instance === item.url);
              if (index !== -1) {
                this.selectedBucketItems.splice(index, 1);
              } else {
                this.selectedBucketItems.push(item.url);
              }
              if (this.excludedBucketItems.includes(item.url)) {
                const excludeIndex = this.excludedBucketItems.findIndex(data => data === item.url);
                this.excludedBucketItems.splice(excludeIndex, 1);
                this.bucketFiltersForPayload.total -= 1;
              }
            }
          } else {
            const index = this.excludedBucketItems.findIndex(instance => instance === item.url);
            if (index !== -1) {
              this.excludedBucketItems.splice(index, 1);
            } else {
              this.excludedBucketItems.push(item.url);
            }
          }
        } else {
          const index = this.selectedBucketItems.findIndex(instance => instance === item.url);
          if (index !== -1) {
            this.selectedBucketItems.splice(index, 1);
          } else {
            this.selectedBucketItems.push(item.url);
          }
        }
      }
    },
    openAddTestCardPopup(cloudItem) {
      if (!this.isAddTestDisabled(cloudItem)) {
        if (cloudItem.status === CONFIGURATION.CLOUD_STATUS.exposed) {
          this.addTestCardPopup = true;
          this.cloudAssetForTestCard = {
            configData: cloudItem.url,
            ...cloudItem,
            organization: this.configurationCloudAccounts.find(item => item.configData === (cloudItem.tld || ''))?.organization || {},
          };
        }
      }
    },
    async initiateAction({ action, item }) {
      if (this.isCloudInstancesTab) {
        if (action === CONFIGURATION.CLOUD_ACTIONS_TYPES.suppress) {
          this.suppressAssetsPopup = true;
          this.itemToSuppress = item;
        } else if (action === CONFIGURATION.CLOUD_ACTIONS_TYPES.unsuppressed) {
          this.unsuppressedItemPopup = true;
          this.itemToUnsuppressed = item;
        }
      } else if (action === CONFIGURATION.BUCKET_ACTIONS_TYPES.suppress) {
        this.suppressAssetsPopup = true;
        this.itemToSuppress = item;
      } else if (action === CONFIGURATION.BUCKET_ACTIONS_TYPES.unsuppressed) {
        this.unsuppressedItemPopup = true;
        this.itemToUnsuppressed = item;
      }
    },
    async downloadCSVReport() {
      let payload = {};
      if (this.isCloudInstancesTab) {
        payload = {
          sort: { default: 'asc' },
          search: this.searchCloud,
          filter: this.filterFormattedCloud,
          toggles: {
            exposed: this.exposedCloud,
            showSuppress: this.showSuppressCloud,
          },
          domain: this.domainFilter || [],
          organizations: this.organizationFilter || [],
          tab: 'cloudInstances',
        };
      } else if (this.isCloudBucketsTab) {
        payload = {
          sort: { default: 'asc' },
          search: this.searchBucket,
          filter: this.filterFormattedBucket,
          toggles: {
            exposed: this.exposedBucket,
            showSuppress: this.showSuppressBucket,
          },
          domain: this.domainFilter || [],
          organizations: this.organizationFilter || [],
          tab: 'cloudBuckets',
        };
      }
      const tabName = this.isCloudInstancesTab ? 'cloud-instances' : 'cloud-buckets';
      const dataStream = await downloadCSVReportByTab(payload);
      const blob = new Blob([dataStream], { type: 'text/plain' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', `${Date.now()}-${tabName}.csv`);
      document.body.appendChild(link);
      link.click();
    },
    searchChange(e) {
      if (this.isCloudInstancesTab) {
        this.searchCloud = e.trim();
      } else if (this.isCloudBucketsTab) {
        this.searchBucket = e.trim();
      } else {
        this.searchServices = e.trim();
      }
    },
    filtersChange(e) {
      if (this.isCloudInstancesTab) {
        this.filterSearchCloud = e;
        this.filterFormattedCloud = this.extractFiltersCloud();
      } else if (this.isCloudBucketsTab) {
        this.filterSearchBucket = e;
        this.filterFormattedBucket = this.extractFiltersBucket();
      } else {
        this.filterSearchServices = e;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/design-system';

.cloud-tab-loading {
  align-self: center;
  justify-self: center;
  margin-top: 20%;
}

.cloud-assets-tab {
  padding: $space-4 $space-8;
  position: relative; // Required for contained loading overlay
  min-height: calc(100vh - 200px); // Ensure overlay has space to display

  &__pagination {
    padding-top: $space-5;
  }

  &__header {
    display: flex;
    flex-direction: column;

    &__top {
      display: flex;
      margin-bottom: $space-4;
      justify-content: space-between;
      align-items: center;
      min-height: rem(49);

      &__left {
        display: flex;

        .search-filter {
          margin-top: -$space-2;
          width: rem(850);
        }

        &__filter {
          padding-left: $space-12;
          margin-top: -$space-4;
        }

        &__show-suppress {
          padding-left: $space-12;
          margin-top: -$space-4;
        }
      }

      &__toggle-suppress {
        display: flex;
        align-items: center;

        .toggle-suppress-asset {
          background-color: $good-button-background-color !important;
          border-radius: $radius-sm;
          box-shadow: $shadow-sm;
          color: $good-button-text-color !important;
          font-family: $default-application-font-medium;
          font-size: $font-size-sm;
          height: $space-8;
          letter-spacing: 1.07px;
          line-height: $space-4;

          .complience-degrees-icon {
            fill: $good-button-text-color;
            width: rem(28);
            padding-right: $space-1;
          }

          &.toggle-suppress-asset--suppress {
            background-color: var(--text-secondary) !important;
            color: #ffffff !important;
          }

          &.v-btn--disabled {
            background-color: var(--bg-tertiary) !important;
            color: var(--text-muted) !important;
            .complience-degrees-icon {
              fill: var(--text-muted);
            }
          }
        }
      }

      .download-csv-btn {
        color: var(--text-inverse);
        font-family: $default-application-font-medium;
        font-size: $font-size-sm;
        height: $btn-height-md;
        letter-spacing: 1.1px;
        line-height: $font-size-md;
        width: rem(78);
        margin-left: $space-4;

        &:hover {
          cursor: pointer;
        }

        &.disabled {
          opacity: 0.5;
          pointer-events: none;
        }
      }
    }

    &__bottom {
      margin-bottom: $space-5;
      margin-top: $space-5;
      display: flex;
      align-items: center;

      .select-all {
        display: flex;
        margin-right: $space-8;
      }
    }
  }

  .servicesTable {
    margin-top: $space-2;
    max-width: 100%;
  }

  .tab-button {
    color: var(--text-secondary);
    font-family: $default-application-font-regular;
    font-size: $font-size-base;
    line-height: $font-size-base;
    text-align: center;
  }
}
</style>

<style lang="scss">
// Override Element UI's default blue active/hover colors for cloud sub-tabs — matches prod my.cynergy.app
.cloud-assets-tab .tab-group {
  .el-radio-button__inner {
    color: #606266 !important;
  }

  .el-radio-button__inner:hover {
    color: #657D94 !important;
  }

  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background-color: #657D94 !important;
    border-color: #657D94 !important;
    box-shadow: -1px 0 0 0 #657D94 !important;
    color: #ffffff !important;
  }
}
</style>
